import { Box, Button, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { generatePath, Link } from 'react-router-dom';
import { EligibilityFailContent } from '../../components/eligibility-fail-content/EligibilityFailContent';
import { EligibilityItem } from '../../components/eligibility-fail-content/types';
import { useGetSignedInUser } from '../../hooks/useGetSignedInUser';
import { APP_URLS } from '../../routes/urls';
import {
  ApplyForProgramsOrScholarshipsResponse,
  ApplyModule,
  EligibilityFailResult,
} from '../../store/features/apply/types';
import { applyScreenStyles } from './styles';

interface ApplyEligibilityFailProps {
  module: ApplyModule;
  isSuccess: boolean;
  data: ApplyForProgramsOrScholarshipsResponse | undefined;
  onCloseBtnClick: () => void;
  eligibilityItems: EligibilityItem | EligibilityItem[];
}
export const ApplyEligibilityFail: React.FC<ApplyEligibilityFailProps> = ({
  module,
  isSuccess,
  data,
  onCloseBtnClick,
  eligibilityItems,
}) => {
  const { currentData: userData } = useGetSignedInUser();

  const canShowEligibilityFailDetails = userData?.user?.educations ? userData.user.educations.length > 0 : false;
  const isEligibilityFail = isSuccess && data && 'isEligible' in data && !data.isEligible;

  if (!isEligibilityFail) return null;
  return (
    <>
      {canShowEligibilityFailDetails && (
        <DialogTitle sx={{ bgcolor: 'error.main', color: 'common.white', fontSize: '1.125rem!important', py: 1.5 }}>
          <Box component="span">Oops..</Box>, sorry you are not eligible to apply in these{' '}
          {module === 'institute_programs' ? 'programs' : 'scholarships'}
        </DialogTitle>
      )}
      <DialogContent sx={canShowEligibilityFailDetails ? { px: 0 } : applyScreenStyles.centeredDialogContent}>
        <EligibilityFailContent
          onCloseBtnClick={onCloseBtnClick}
          EmptyEducationContainerProps={{
            sx: [applyScreenStyles.centeredDialogContent, applyScreenStyles.emptyEducationFailContent],
          }}
          eligibilityItems={eligibilityItems}
          results={data.results as EligibilityFailResult[]}
        />
      </DialogContent>
      {canShowEligibilityFailDetails && (
        <DialogActions>
          <Grid justifyContent="flex-end" container spacing={1.5}>
            {userData?.user && (
              <Grid item>
                <Button
                  component={Link}
                  to={generatePath(APP_URLS.editEducationInfo, { studentSlug: userData.user.slug })}
                  variant="default"
                >
                  Update Education Details
                </Button>
              </Grid>
            )}
            <Grid item>
              <Button onClick={onCloseBtnClick} variant="contained">
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      )}
    </>
  );
};
